import api from "./api";
import { parsePaginatedList, asList } from "../utils/pagination";

export interface Supplier {
  id: string;
  name: string;
  contactPerson?: string | null;
  email?: string | null;
  phone?: string | null;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  country?: string | null;
  postalCode?: string | null;
  taxId?: string | null;
  website?: string | null;
  isActive: boolean;
  createdAt?: string;
}

export type SupplierPayload = Partial<
  Omit<Supplier, "id" | "createdAt" | "isActive">
> & {
  name: string;
  isActive?: boolean;
};

const supplierAPI = {
  getSuppliers: async (params?: {
    pageNo?: number;
    pageSize?: number;
    search?: string;
    isActive?: boolean | string;
  }): Promise<{ data: Supplier[]; total: number }> => {
    const response = await api.get("/suppliers", { params });
    return parsePaginatedList<Supplier>(response.data.data);
  },

  getAllSuppliers: async (): Promise<Supplier[]> => {
    const response = await api.get("/suppliers/all");
    return asList<Supplier>(response.data.data);
  },

  createSupplier: async (data: SupplierPayload): Promise<Supplier> => {
    const response = await api.post("/suppliers", data);
    return response.data.data;
  },

  updateSupplier: async (
    id: string,
    data: Partial<SupplierPayload>
  ): Promise<Supplier> => {
    const response = await api.put(`/suppliers/${id}`, data);
    return response.data.data;
  },

  deleteSupplier: async (id: string): Promise<void> => {
    await api.delete(`/suppliers/${id}`);
  },
};

export default supplierAPI;
